import { Grid } from "@mui/material";
import { EnrollmentTabLabelProps, StatusIcon } from "../../../../types/components/enrollmentProps.types";

import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LockIcon from "@mui/icons-material/Lock";

import "./enrollmentTabLabel.css";
import { getVEBPlanCaption } from "../../../../utils/commonFunctions/plan";
import { VEBPlanName } from "../../../../types/plan.types";
import { useState } from "react";
const getStatusIcon: StatusIcon = {
	ACTIVE: <DoneAllOutlinedIcon className="status-icon" />,
	SUBMITTED: <DoneAllOutlinedIcon className="status-icon" />,
	WAIVED: <PanToolOutlinedIcon className="status-icon" />,
	OPENED: <ArrowForwardIosIcon className="status-icon open-icon" />,
	CLOSED: <LockIcon className="status-icon" />
};

const EnrollmentTabLabel = ({ planName, status, isOpenEnrollment }: EnrollmentTabLabelProps): JSX.Element => {
	return (
		<div className="enrollment-tab-level">
			<Grid
				container
				spacing={0}
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				wrap="nowrap"
			>
				{/* Plan name — takes remaining space */}
				<Grid
					item
					style={{
						display: "flex",
						flex: 1,
						alignItems: "center",
						justifyContent: "flex-start",
						overflow: "hidden",
						minHeight: "0px" /* increased height */,
						marginBottom: "-15px",
						paddingRight: "6px"
					}}
				>
					<div className="plan-name">
						{planName === "Family Protection" ? "Term Life To Age 121" : planName}
					</div>
				</Grid>

				{/* Status icon — fixed width, never shrinks */}
				<Grid
					item
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexShrink: 0,
						width: "24px",
						overflow: "hidden"
					}}
				>
					{isOpenEnrollment ? (
						<div className="open-icon-container">{getStatusIcon["OPENED"]}</div>
					) : status ? (
						<div className="status-container">{getStatusIcon[status as keyof StatusIcon]}</div>
					) : null}
				</Grid>
			</Grid>
		</div>
	);
};

export default EnrollmentTabLabel;
